<ion-radio-group
  [value]="selectedAttraction"
  (ionChange)="handleSelectAttraction($event)"
>
  <ng-container
    *ngFor="let attraction of attractions?.locations; let index = index"
  >
    <ng-container *ngIf="index < attractionLength">
      <ion-card class="border-r10 ion-no-margin ion-margin-top">
        <ion-card-content>
          <div
            class="d-flex ion-justify-content-start ion-align-items-start marb10"
          >
            <ion-radio slot="start" [value]="attraction"></ion-radio>
            <h2
              class="fs-4 font600 card-primary-text-color ion-no-margin variant-name"
            >
              {{ attraction?.variantName }}
            </h2>
          </div>
          <p class="fs-3 font400 card-primary-text-color">
            Duration - {{ attraction?.duration }}
          </p>
          <ng-container *ngIf="travellerCount.adult > 0">
            <p class="fs-3 font400 card-primary-text-color">
              {{ travellerCount.adult }} Adult x
              {{ attraction?.adultPrice | currency : currencyCode }}
            </p>
          </ng-container>
          <ng-container *ngIf="travellerCount.children > 0">
            <p class="fs-3 font400 card-primary-text-color">
              {{ travellerCount.children }} Children x
              {{ attraction?.childPrice | currency : currencyCode }}
            </p>
          </ng-container>
          <ng-container *ngIf="travellerCount.infant > 0">
            <p class="fs-3 font400 card-primary-text-color">
              {{ travellerCount.infant }} Infant x
              {{ attraction?.infantPrice | currency : currencyCode }}
            </p>
          </ng-container>
          <h6 class="fs-4 font700 card-primary-text-color mart6">
            Total
            {{ calculateTotalPrice(attraction) | currency : currencyCode }}
          </h6>
          <p class="fs-2 font400">(Price includes taxes and booking fees)</p>
          <div class="time-container">
            <ng-container *ngIf="attraction?.timeSlots?.length > 0">
              <ion-button
                *ngFor="let time of attraction?.timeSlots; let idx = index"
                [ngClass]="
                  selectedTime.index === idx &&
                  selectedAttraction?.id === attraction?.id
                    ? 'primary-btn'
                    : 'white-btn'
                "
                class="fs-3 font600 time-button"
                [disabled]="selectedAttraction?.id !== attraction?.id"
                (click)="handleSelectTime(idx, time)"
              >
                {{ time }}
              </ion-button>
            </ng-container>
          </div>
        </ion-card-content>
      </ion-card>
    </ng-container>
  </ng-container>
</ion-radio-group>
